<div class="page-title">
  <h1>Pessoas cadastradas</h1>
  @if(mustShowAddButton()) {
  <button matButton="filled" (click)="adicionarPessoa()">
    <span style="margin-right: 6px; font-size: 16px">+</span> Adicionar
  </button>
  }
</div>

<div class="filters">
  <mat-form-field appearance="outline" style="width: 30%">
    <mat-select
      [(ngModel)]="empresaFiltrada"
      (selectionChange)="filtrarPorEmpresa()"
    >
      <mat-option selected value="">Empresa</mat-option>
      <mat-option
        *ngFor="let option of empresas.data"
        [value]="option.nomeFantasia"
      >
        {{ option.nomeFantasia }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="custom-outline-red">
    <input
      placeholder="Buscar por nome e número do documento"
      matInput
      type="text"
      [(ngModel)]="fieldText"
      (input)="updateFieldText($event)"
    />
  </mat-form-field>
</div>

<table mat-table [dataSource]="pessoas" class="cis-default-table" matSort>
  <ng-container matColumnDef="nome">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
    <td mat-cell *matCellDef="let pessoa">
      <span style="font-weight: 600">{{pessoa.nomeCompleto}}</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="tipoDoc">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Documento de identificação
    </th>
    <td mat-cell *matCellDef="let pessoa">
      <!-- CPF -->
      <p
        class="tipo-documento-cell"
        (click)="verDetalhes(pessoa.idPessoa)"
        *ngIf="pessoa.idTipoDocumento == 1"
      >
        {{pessoa.tipoDocumentoNome}}
      </p>

      <!-- Passaporte -->
      <p
        class="tipo-documento-cell"
        (click)="verDetalhes(pessoa.idPessoa)"
        *ngIf="pessoa.idTipoDocumento == 2"
      >
        {{pessoa.tipoDocumentoNome}}
      </p>

      <!-- CRNM -->
      <p
        class="tipo-documento-cell"
        (click)="verDetalhes(pessoa.idPessoa)"
        *ngIf="pessoa.idTipoDocumento == 3"
      >
        {{pessoa.tipoDocumentoAbreviacao}}
        <img
          class="tipo-documento-cell-tooltip"
          src="../../../../assets/svg/icons/info_cinza_ic.svg"
          [matTooltip]="pessoa.tipoDocumentoNome"
          matTooltipPosition="below"
          alt=""
        />
      </p>

      <!-- CIE -->
      <p
        class="tipo-documento-cell"
        (click)="verDetalhes(pessoa.idPessoa)"
        *ngIf="pessoa.idTipoDocumento == 4"
      >
        {{pessoa.tipoDocumentoAbreviacao}}
        <img
          class="tipo-documento-cell-tooltip"
          src="../../../../assets/svg/icons/info_cinza_ic.svg"
          [matTooltip]="pessoa.tipoDocumentoNome"
          matTooltipPosition="below"
          alt=""
        />
      </p>
    </td>
  </ng-container>

  <ng-container matColumnDef="numDoc">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Número do documento
    </th>
    <td
      mat-cell
      *matCellDef="let pessoa"
      (click)="verDetalhes(pessoa.idPessoa)"
    >
      {{pessoa.numeroDocumento}}
    </td>
  </ng-container>

  <ng-container matColumnDef="cargo">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Cargo</th>
    <td
      mat-cell
      *matCellDef="let pessoa"
      (click)="verDetalhes(pessoa.idPessoa)"
    >
      {{pessoa.cargo}}
    </td>
  </ng-container>

  <ng-container matColumnDef="telefone">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Telefone celular</th>
    <td
      mat-cell
      *matCellDef="let pessoa"
      (click)="verDetalhes(pessoa.idPessoa)"
    >
      {{pessoa.telefoneCelular}}
    </td>
  </ng-container>

  <ng-container matColumnDef="empresa">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Empresa</th>
    <td
      mat-cell
      *matCellDef="let pessoa"
      (click)="verDetalhes(pessoa.idPessoa)"
    >
      {{pessoa.empresaNomeFantasia}}
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns;"
    (click)="verDetalhes(row.idPessoa)"
  ></tr>
</table>

<div class="paginator-container">
  <p>{{ textoContagem }}</p>
  <mat-paginator
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    [showFirstLastButtons]="false"
    [selectConfig]="{ disableOptionCentering: true, panelClass: 'custom-paginator-select' }"
  >
  </mat-paginator>
</div>
